import { ScrollTrigger } from "gsap/all";

class Video {
  constructor($el) {
    this.$el = $el;
    this.init();
  }

  init = () => {
    ScrollTrigger.create({
      trigger: this.$el,
      start: 'top bottom',
      end: 'bottom top',
      markers: false,
      onEnter: () => {
        this.play();
      },
      onEnterBack: () => {
        this.play();
      },
      onLeave: () => {
        this.pause();
      },
      onLeaveBack: () => {
        this.pause();
      },
    });
  }

  play = () => {
    this.$el[0].play();
  }

  pause = () => {
    this.$el[0].pause();
  }
}

export default Video;